import type { CrudConfig } from '@/components/GenericCrudPage';

export const notificationsConfig: CrudConfig = {
  resource: 'notifications',
  title: '通知管理',
  rowKey: 'id',
  searchFields: ['notification_type', 'audience_type'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'title', label: '标题', type: 'text', required: true, ellipsis: true },
    { name: 'content', label: '内容', type: 'textarea', required: true, hideInTable: true },
    {
      name: 'notification_type',
      label: '类型',
      type: 'select',
      required: true,
      width: 120,
      options: [
        { label: '系统消息', value: 'SYSTEM', color: 'blue' },
        { label: '营销推送', value: 'MARKETING', color: 'gold' },
        { label: '考试通知', value: 'EXAM', color: 'purple' },
        { label: '订单通知', value: 'ORDER', color: 'green' },
      ],
    },
    {
      name: 'audience_type',
      label: '受众',
      type: 'select',
      width: 120,
      options: [
        { label: '全体用户', value: 'ALL' },
        { label: '按行业', value: 'BY_INDUSTRY' },
        { label: '订阅用户', value: 'SUBSCRIBED' },
        { label: '指定用户', value: 'SPECIFIC' },
      ],
    },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100, hideInTable: true, tooltip: 'audience_type=BY_INDUSTRY 时填' },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 110,
      options: [
        { label: '草稿', value: 'DRAFT', status: 'Default' },
        { label: '已发送', value: 'SENT', status: 'Success', color: 'green' },
        { label: '已撤回', value: 'WITHDRAWN', status: 'Error', color: 'red' },
      ],
    },
    { name: 'scheduled_at', label: '定时发送', type: 'datetime', width: 180, hideInTable: true },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true },
  ],
};
